import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { SsoState } from '../../../store/sso/sso.state';
import { environment } from 'src/environments/environment';

export const ssoAuthGuard: CanActivateFn = route => {
  const store = inject(Store);
  const isAuthenticated = store.selectSnapshot(SsoState.isAuthenticated);

  if (!isAuthenticated) {
    window.location.href = `${environment.sso.url}`;
    return false;
  }

  return true;
};
